import React, { useEffect } from "react";
import { Platform, View, BackHandler, Alert } from "react-native";
import { ScreenNameList } from "@lib/utilities/Constants";
import { withPolicyDataFetching } from "../../hoc/withFetchPolicyData";
import { styles, ids } from "./Style";
import BillingContent from "../../components/billing/BillingContent";
import { useBillingPayments } from "@lib/hooks/billing/useBillingPayments";
import PageWrapper from "../../components/common/PageWrapper";
import { messages } from "../../resources/strings";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import MainContainer from "../../components/common/MainContainer";
import Payments from "../../components/Payments/Payments";
import { useNavigation } from "@react-navigation/native";

const BillingPayments = () => {
  const navigation = useNavigation();
  const {
    isPaymentVisible,
    errorData,
    loading,
    expandedIndex,
    billings,
    payments,
    policyData,
    toggleExpandedView,
    onReloadPress,
    getTotalPaymentAmount,
    setErrorHandle,
    onPaymentModalClose,
    onPaymentButtonPress,
    isPayNowVisible,
    refetchData,
  } = useBillingPayments();

  useEffect(() => {
    const onBackPress = () => true;

    if (Platform.OS === "android") {
      if (isPaymentVisible) {
        const subscription = BackHandler.addEventListener(
          "hardwareBackPress",
          onBackPress,
        );

        return () => subscription.remove();
      }
    } else {
      navigation.setOptions({
        gestureEnabled: !isPaymentVisible,
      });
    }
  }, [isPaymentVisible, navigation]);

  return (
    <MainContainer
      screenName={ScreenNameList.billingPayments}
      navigation={navigation}
      errorData={errorData}
      onReloadPress={onReloadPress}
      onEndTimer={() => setErrorHandle(messages.error.noError)}
    >
      <View
        style={[styles.topParentView]}
        dataSet={{ media: ids.topParentView }}
      >
        <PageWrapper
          screenName={ScreenNameList.billingPayments}
          navigation={navigation}
          isLoading={loading}
          arrayPolicyList={policyData.policies}
        >
          <BillingContent
            isPayNowVisible={isPayNowVisible}
            onPaymentButtonPress={onPaymentButtonPress}
            billingDetails={billings}
            paymentsArray={payments}
            expandedIndex={expandedIndex}
            toggleExpandedView={toggleExpandedView}
            getTotalPaymentAmount={getTotalPaymentAmount}
          />
        </PageWrapper>
        {isPaymentVisible && (
          <Payments
            refetchData={refetchData}
            onClose={onPaymentModalClose}
            onError={(er) => {
              setErrorHandle(er);
              onPaymentModalClose();
            }}
          />
        )}
      </View>
    </MainContainer>
  );
};

export default Platform.OS == "web"
  ? withAuthenticationRequired(withPolicyDataFetching(BillingPayments))
  : withPolicyDataFetching(BillingPayments);
